import PlayNGoGameContainer from './playngo-game-container'
import connector from './connector'

export default connector(PlayNGoGameContainer)
